export async function initInstaFeed() {
  const container = document.getElementById('instaFeedWrap');
  if (!container) return;

  container.innerHTML = "";
  container.insertAdjacentHTML('beforeend', '<ul id="instaFeed" class="p-insta__list"></ul>');
  
  const cards = 9;
  const businessId = '17841406647374329';
  const token = 'EAANzhuz3ZBd8BRCmVqRfW0K8MrGM8ZAoEJWClgtAao3xEQKMs0A0ZCHluDP4mEKc4ehD5T63HV6uIKU3q0SKZCrcZBFBCFZB1IFKuDp9YTGc6lsWUWaLZAlc3u8qOwRxOoLefBc5QsVduKXDiKZCyEzDvEWH7thJGvT8uFYHRXIf0S47FqqYD63BtnZBEbvZCyuD6l2K7j';

  try {
    const response = await fetch(
      `https://graph.facebook.com/v19.0/${businessId}?fields=name,media.limit(${cards}){caption,media_url,thumbnail_url,permalink,media_type}&access_token=${token}`
    );
    
    if (response.status === 200) {
      const resObjects = await response.json();
      const mediaData = resObjects.media.data;

      mediaData.forEach((item) => {
        const imgUrl = item.media_type === 'VIDEO' ? item.thumbnail_url : item.media_url;
        if (imgUrl) {
          document.querySelector('#instaFeed').insertAdjacentHTML(
            'beforeend',
            `<li><a href="${item.permalink}" target="_blank" rel="noopener"><img src="${imgUrl}" alt="${item.caption || ''}" loading="lazy"></a></li>`
          );
        }
      });
    }
  } catch (error) {
    container.insertAdjacentHTML('beforeend', `<p style="text-align:center;width:100%;">読み込めませんでした</p>`);
  }
}